import * as yup from 'yup';
import { CurrencyCode, } from '../../types';
import { ExistsInEpic } from '../../types/ExistsInEpic';
export const AverageTicketRequestSchema = yup.object({
    currencyCode: yup.string().oneOf(Object.values(CurrencyCode)).required(),
    startDate: yup.date().required(),
    endDate: yup.date().required(),
});
export const MonthlyActivationsRequestSchema = yup.object({
    startDate: yup.date().required(),
    endDate: yup.date().required(),
});
export const MonthlyTransactionsAndAppliedProfitByPaymentMethodRequestSchema = yup.object({
    currencyCode: yup.string().oneOf(Object.values(CurrencyCode)).required(),
});
export const MonthlyTransactionsAndAppliedProfitRequestSchema = yup.object({
    currencyCode: yup.string().oneOf(Object.values(CurrencyCode)).required(),
});
export const MonthlyTop10AccountsRequestSchema = yup.object({
    currencyCode: yup.string().oneOf(Object.values(CurrencyCode)).required(),
});
export const editPaymentSchema = yup.object().shape({
    paymentId: yup.number().integer().required(),
    existsInEpic: yup.mixed().oneOf(Object.values(ExistsInEpic)).optional(),
});
export var JobStatus;
(function (JobStatus) {
    JobStatus["IN_PROGRESS"] = "IN_PROGRESS";
    JobStatus["COMPLETE"] = "COMPLETE";
    JobStatus["FAILED"] = "FAILED";
})(JobStatus || (JobStatus = {}));
export var JobType;
(function (JobType) {
    JobType["LEGACY"] = "LEGACY";
    JobType["BATCH_SETTLEMENT"] = "BATCH_SETTLEMENT";
    JobType["BATCH_CAPTURE"] = "BATCH_CAPTURE";
    JobType["AUTOPAY"] = "AUTOPAY";
    JobType["LOCKBOX"] = "LOCKBOX";
    JobType["BALANCE_PLATFORM"] = "BALANCE_PLATFORM";
    JobType["MARKETPAY_PAYOUT_REPORT"] = "MARKETPAY_PAYOUT_REPORT";
    JobType["BALANCE_PLATFORM_MARKETPAY_PAYOUT_REPORT"] = "BALANCE_PLATFORM_MARKETPAY_PAYOUT_REPORT";
    JobType["PAYMENTS_ACCOUNTING_REPORT"] = "PAYMENTS_ACCOUNTING_REPORT";
    JobType["BALANCE_PLATFORM_ACCOUNTING_REPORT"] = "BALANCE_PLATFORM_ACCOUNTING_REPORT";
    JobType["MARKETPLACE_ACCOUNTING"] = "MARKETPLACE_ACCOUNTING";
    JobType["MARKETPAY_BALANCE_REPORT"] = "MARKETPAY_BALANCE_REPORT";
    JobType["BALANCE_PLATFORM_MARKETPAY_ACCOUNTING_REPORT"] = "BALANCE_PLATFORM_MARKETPAY_ACCOUNTING_REPORT";
    JobType["BALANCE_PLATFORM_ACCOUNT_HOLDER_BALANCE_REPORT"] = "BALANCE_PLATFORM_ACCOUNT_HOLDER_BALANCE_REPORT";
})(JobType || (JobType = {}));
export const acknowledgeDisputeSchema = yup.object({
    chargebackIds: yup.array().when('acknowledgeAll', {
        is: true,
        then: (schema) => schema.max(0).optional(),
        otherwise: (schema) => schema.of(yup.number().required()).min(1).required(),
    }),
    acknowledgeAll: yup.boolean().optional(),
});
export var PaymentRequestStatus;
(function (PaymentRequestStatus) {
    PaymentRequestStatus["PAID"] = "PAID";
    PaymentRequestStatus["UNPAID"] = "UNPAID";
})(PaymentRequestStatus || (PaymentRequestStatus = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["PREMIUM_FINANCE"] = "PREMIUM_FINANCE";
    TransactionType["PAID_IN_FULL"] = "PAID_IN_FULL";
})(TransactionType || (TransactionType = {}));
export const isPremiumFinanceTransaction = (row) => {
    return row.transactionType === TransactionType.PREMIUM_FINANCE;
};
export var PayoutType;
(function (PayoutType) {
    PayoutType["STANDARD"] = "STANDARD";
    PayoutType["LOCKBOX"] = "LOCKBOX";
})(PayoutType || (PayoutType = {}));
//# sourceMappingURL=reporting.js.map